import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header-creativity',
  templateUrl: './header-creativity.component.html',
  styleUrls: ['./header-creativity.component.scss']
})
export class HeaderCreativityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
